import React from "react";
import { ArrowRight } from "lucide-react";

const CTASection = () => {
  return (
    <section className="py-20">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="relative rounded-3xl border border-white/[0.06] bg-[#0a0a0c] overflow-hidden">
          {/* Atmospheric glow */}
          <div className="absolute inset-0">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-[radial-gradient(ellipse_at_center,_rgba(120,80,200,0.08)_0%,_rgba(80,50,180,0.04)_40%,_transparent_70%)]" />
          </div>

          {/* Grid pattern */}
          <div
            className="absolute inset-0 opacity-[0.02]"
            style={{
              backgroundImage: `linear-gradient(rgba(255,255,255,0.15) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.15) 1px, transparent 1px)`,
              backgroundSize: "40px 40px",
            }}
          />

          <div className="relative py-20 px-8 text-center">
            <h2 className="text-3xl md:text-[2.75rem] font-bold text-white tracking-[-0.02em] leading-tight mb-4 max-w-lg mx-auto">
              Ready to build your creative vault?
            </h2>
            <p className="text-[#666] text-base leading-relaxed max-w-md mx-auto mb-10">
              Join 10,000+ marketers who save hours every week finding ad inspiration.
              Start free, upgrade when you need more.
            </p>
            <div className="flex items-center justify-center gap-4">
              <a
                href="#signup"
                className="inline-flex items-center gap-2.5 bg-white text-black font-medium text-sm rounded-full px-8 py-3.5 transition-all duration-300 hover:shadow-[0_0_30px_rgba(255,255,255,0.15)] hover:bg-white/95 group"
              >
                Start for free
                <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5" />
              </a>
              <a
                href="#pricing"
                className="text-sm text-[#666] hover:text-white/80 transition-colors duration-300"
              >
                View pricing
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
